import { render, staticRenderFns } from "./AddRuleStepNotificationDefinition.vue?vue&type=template&id=665484f1"
import script from "./AddRuleStepNotificationDefinition.vue?vue&type=script&lang=js"
export * from "./AddRuleStepNotificationDefinition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports